import { createContext, useContext } from 'react'
import { WebPushNotificationsClient } from './webPushNotificationsClient'

export const WebPushNotificationsContext = createContext<{
    client: WebPushNotificationsClient
} | null>(null)

export const useWebPushNotificationsContext = () => useContext(WebPushNotificationsContext)
